<template>
    <div class="activate-articles-page">
        <ui5-button @click="deactivateAll">{{ trans('pages.activate_articles.deactivate_all') }}</ui5-button>
        <ui5-button @click="loadInactiveCodes">
            {{ trans('pages.activate_articles.load_inactive_codes') }}
        </ui5-button>
        <div>
            <ui5-label>
                {{ trans('pages.activate_articles.reactivate_codes_label') }}
            </ui5-label>
            <ui5-textarea
                :placeholder="trans('pages.activate_articles.article_codes_placeholder')"
                :growing="true"
                growing-max-lines="20"
                @input="codes = $event.target.value"
                :value="codes" />
            <ui5-button @click="activateCodes">{{ trans('pages.activate_articles.reactivate_button') }}</ui5-button>
            <pre v-if="responseData">{{ responseData }}</pre>
        </div>
    </div>
</template>
<script>
import profileApi from '../api/profile';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import ErrorHelper from '../helpers/ErrorHelper';
import localization from '../mixins/localization';

export default {
    name: 'ActivateArticlesPage',
    mixins: [localization],
    mounted() {},
    data() {
        return {
            codes: '',
            responseData: null,
        };
    },
    methods: {
        loadInactiveCodes() {
            profileApi
                .loadInactiveCodes()
                .then((response) => {
                    this.codes = response.data.data.join('\n');
                })
                .catch(() => {
                    showErrorMessage(this.trans('pages.activate_articles.error_loading_inactive'));
                });
        },
        deactivateAll() {
            profileApi
                .reset()
                .then(() => {
                    showInfoMessage(this.trans('pages.activate_articles.all_deactivated'));
                })
                .catch(() => {
                    showErrorMessage(this.trans('pages.activate_articles.error_deactivating'));
                });
        },
        activateCodes() {
            this.responseData = null;
            const codes = this.codes.split(/\r?\n/).map((x) => x.trim());
            profileApi
                .activateMultiple(codes)
                .then((response) => {
                    showInfoMessage(this.trans('pages.activate_articles.activation_complete'));
                    this.responseData = response.data.data;
                })
                .catch((error) => {
                    this.responseData = ErrorHelper.parseError(
                        error.response.data
                    );
                    showErrorMessage(this.trans('pages.activate_articles.error_activating'));
                });
        },
    },
};
</script>
